<template>
  <div style="padding:15px;" v-loading="loading">
    <div style="padding:0 0 5px 5px">
      <span style="font-size:14px;font-weight:bold"> 标签完成度：</span>
      不看cc
      <el-switch v-model="noCC" @change="loadData">
      </el-switch>
    </div>
    <el-table
      :data="tableData"
      border
      size="mini"
      style="width: 100%">
      <el-table-column
        type="index"
        width="40"
        fixed="left">
      </el-table-column>
      <el-table-column
        v-for="item in heads"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        sortable
        :fixed="item.label=='职能模块'?true:false"
        >
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      loading: false,
      tableData: [],
      heads: [
        { prop: '职能模块', label: '职能模块', width: 170 },
        { prop: '负责人', label: '负责人', width: 200 },
        { prop: '总人数', label: '总人数', width: 90 },
        { prop: '总完成度', label: '总完成度%', width: 110 },
        { prop: '职级', label: '职级%', width: 90 },
        { prop: '业绩', label: '业绩%', width: 90 },
        { prop: '地域', label: '地域%', width: 90 },
        { prop: '性别', label: '性别%', width: 90 },
        { prop: '平台', label: '平台%', width: 90 },
        { prop: '公司', label: '公司%', width: 90 },
        { prop: '目前职位', label: '目前职位%', width: 110 },
        { prop: '部门', label: '部门%', width: 90 },
        { prop: '本科院校', label: '本科院校%', width: 110 },
        { prop: '硕士院校', label: '硕士院校%', width: 110 },
        { prop: '学历', label: '学历%', width: 90 },
        { prop: '细分职能', label: '细分职能%', width: 110 },
        { prop: '擅长方向', label: '擅长方向%', width: 110 },
        { prop: '个性标签', label: '个性标签%', width: 110 },
        { prop: 'thirdId', label: '协会绑定%', width: 110 },
        { prop: '固薪', label: '固薪%', width: 110 },
        { prop: '奖金', label: '奖金%', width: 110 },
        { prop: '全薪', label: '全薪%', width: 110 },
      ],
      noCC: false
    }
  },
  methods: {
    loadData: async function () {
      this.loading = true;
      const res = await app.service('radish').listCompletion({noCC: this.noCC});
      console.log(res)
      if (res.status == 'success') {
        this.tableData = res.data;
      }
      this.loading = false;
    }
  },
  mounted() {
    this.loadData();
  },
}
</script>
